import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $type?: 'balance' | 'rightBig' | undefined;
}

export const ModalGroupBtn = styled.div<IProps>`
  bottom: constant(safe-area-inset-bottom) !important;
  bottom: env(safe-area-inset-bottom) !important;
  ${mixin.flex({ justify: 'flex-start' })};
  column-gap: 6px;
  padding: 14px 20px 10px;
  background: #fff;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background-color: inherit;
    position: absolute;
    bottom: -100%;
    left: 0;
    right: 0;
  }

  .btn {
    width: 100%;
    height: 50px;
    line-height: 130%;
    font-size: 15px;
    font-weight: 500;

    &.btn-secondary {
      border: 1px solid #000;
      background-color: #fff;
    }

    &.btn-primary {
      color: #fff;
      background-color: #000;
    }
  }

  &.is-old-app-iphonex {
    bottom: 34px !important;
  }

  &.border-top {
    border-top: 1px solid #eee;
  }

  ${props => {
    switch (props.$type) {
      case 'rightBig':
        return css`
          .btn-secondary {
            width: 28.927%;
          }

          .btn-primary {
            width: 69.185%;
          }
        `;
      default:
        return null;
    }
  }}

  @media ${({ theme }) => theme.media.smMax} {
    column-gap: ${mixin.pxToVw('6')};
    padding: ${mixin.pxToVw('14 20 10')};

    .btn {
      height: ${mixin.pxToVw('50')};
      font-size: ${mixin.pxToVw('15')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    position: relative;
    column-gap: 10px;
    padding: 16px 24px 24px 24px;

    &::after {
      display: none;
    }

    .btn {
      height: 56px;
      font-size: 17px;
    }

    &.border-top {
      border: none;

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 32px;
        width: calc(100% - 64px);
        height: 1px;
        background: #000;
      }
    }
  }
`;
